import React from 'react'

import { getAspectRatioPadding } from './utils/getAspectRatioPadding'

import { TIconProps } from './iconProps'

const IconCloseExperiment: React.FC<TIconProps> = (props) => {
  return (
    <div style={props.style} className={`select-none ${props.className || 'w-24'}`} onClick={props.onClick}>
      <div className="relative h-0" style={getAspectRatioPadding(props.aspectRatio)}>
        <svg xmlns="http://www.w3.org/2000/svg" className="w-full h-full left-0 top-0 absolute" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M12 1c.552 0 1 .448 1 1v9h9c.552 0 1 .448 1 1s-.448 1-1 1h-9v9c0 .552-.448 1-1 1s-1-.448-1-1v-9H2c-.552 0-1-.448-1-1s.448-1 1-1h9V2c0-.552.448-1 1-1z"
            transform="rotate(45 12 12)"
          />
        </svg>
      </div>
    </div>
  )
}
export default IconCloseExperiment
